import { useTranslation } from 'react-i18next';

import FilterTextField from '../../FilterTextField';
import type { AuditFilterBindings } from '../filterBindings';

import FilterGroup from './FilterGroup';

interface ContentFiltersProps {
    bindings: AuditFilterBindings;
}

/**
 * What an entry changed and what its request carried. A value means nothing without the
 * field or path it sits under, and the backend refuses one alone, so each waits for its
 * field.
 */
export default function ContentFilters({ bindings }: ContentFiltersProps) {
    const { filters, onType } = bindings;
    const { t } = useTranslation();
    const hasField = filters.changedField !== undefined;
    const hasPath = filters.metadataPath !== undefined;
    const changedValueHint = hasField ? undefined : t('auditLog.filters.changedValueHint');

    return (
        <FilterGroup legend={t('auditLog.filters.group.content')}>
            <FilterTextField
                field="changedField"
                label={t('auditLog.filters.changedField')}
                filters={filters}
                onType={onType}
            />
            <FilterTextField
                field="changedFrom"
                label={t('auditLog.filters.changedFrom')}
                filters={filters}
                onType={onType}
                disabled={!hasField}
                hint={changedValueHint}
            />
            <FilterTextField
                field="changedTo"
                label={t('auditLog.filters.changedTo')}
                filters={filters}
                onType={onType}
                disabled={!hasField}
                hint={changedValueHint}
            />
            <FilterTextField
                field="metadataPath"
                label={t('auditLog.filters.metadataPath')}
                placeholder={t('auditLog.filters.metadataPathPlaceholder')}
                filters={filters}
                onType={onType}
            />
            <FilterTextField
                field="metadataValue"
                label={t('auditLog.filters.metadataValue')}
                filters={filters}
                onType={onType}
                disabled={!hasPath}
                hint={
                    hasPath
                        ? t('auditLog.filters.metadataValueHint')
                        : t('auditLog.filters.metadataValueNeedsPath')
                }
            />
        </FilterGroup>
    );
}
